import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import Top from '../navigation/top';
import { FormRow } from '../form/formField';

import util from '../../lib/util';

const initialState = {};

const FIELDS = {
    id: { label: 'Db #', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    from: { label: 'from', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    to: { label: 'to', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    cc: { label: 'cc', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    bcc: { label: 'bcc', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    subject: { label: 'subject', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    body: { label: 'body', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    attachments: { label: 'attachments', type: 'json', readonly: true, help: 'Field is DealerWeb only.' },
    response: { label: 'response', type: 'json', readonly: true, help: 'Field is DealerWeb only.' },

    createdDate: { label: 'Created date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    updatedDate: { label: 'Updated date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
};

@observer
class MaillogEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
        this.updateTimer = {};
        const { maillogStore } = this.props.stores;
        maillogStore.load(props.id);
        this.fields = [
            {
                tabname: 'Basics',
                icon: 'fas fa-user-edit',
                fields: ['id', 'from', 'to', 'cc', 'bcc', 'subject', 'body', 'attachments', 'response', 'createdDate', 'updatedDate'].map(f => util.makeField(f, FIELDS)),
            },
        ];
    }

    updateField = async (id, field, value) => {
        const { maillogStore } = this.props.stores;
        maillogStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { maillogStore } = this.props.stores;
        await maillogStore.saveField(id, field, value);
    }

    render(props) {
        const { maillogStore } = this.props.stores;
        const { maillog, saved } = maillogStore;

        let tabIdx = this.fields.findIndex(e => e.tabname === props.tabname);
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return (
            <div>
                <Top {...props} />

                <div class='row'>
                    <div class='col-12'>
                        <div class='d-flex flex-row bd-highlight mb-3'>
                            <div>
                                <a href='/maillogs' class={`mr-2 btn btn-sm btn-warning`}>
                                    <i class={`fas fa-arrow-left mr-1`} />
                                    Back
                                </a>
                            </div>
                            <div>
                                <h4>Edit: {maillog.id}: {maillog.from}: {maillog.subject}</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-12'>
                        <ul class='nav nav-tabs mb-2'>
                            {this.fields.map(tab => (
                                <li class='nav-item'>
                                    <a class={`nav-link ${props.tabname === tab.tabname ? 'active' : ''}`}
                                        href={`/maillogs/${props.maillogid}/${tab.tabname}`}
                                    >
                                        <i class={`${tab.icon} mr-2`} />
                                        {tab.tabname}
                                    </a>
                                </li>
                            ))}
                        </ul>

                        {this.fields[tabIdx].fields.map(field => <FormRow
                            field={field}
                            object={maillog}
                            saved={saved}
                            updateField={this.updateField}
                        />)}

                    </div>
                </div>
            </div>
        );
    }
}

export default MaillogEdit;



// WEBPACK FOOTER //
// ./components/maillogs/edit.js